// extracted by mini-css-extract-plugin
module.exports = {"products":"pl_products__1wIKC"};